export default __webpack_public_path__ + "static/media/avatar-4.28ba470b.png";